import styled from 'styled-components';
import {Form, Input, Button} from 'global/styles/styles.js';

const S = {};

S.ComponentWrapper = styled.div`
    font-size: 12px;
    position: relative;
`;


S.FilterContainer = styled.div`
    width: 100%;
    display: flex;
    position: relative;
    background-color: ${({ theme: { $groupFilterBtnFilterBackgroundColor } }) => $groupFilterBtnFilterBackgroundColor};
`;

S.FilterBtnsList = styled.div`
    background-color: ${({ theme: { $groupFilterBtnFilterBackgroundColor } }) => $groupFilterBtnFilterBackgroundColor};
    width: 100%;
    overflow: hidden;
    height: 3.5rem;
    line-height: 3.5rem;
    margin: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: scroll;
    margin-top: 1px;
    margin-right: 1rem;
    position: relative;
`;

S.FilterBtnsContainer = styled.div`
    justify-content: flex-start;
    display: flex;
    align-items: center;
    position: absolute;
    margin-left: 0px;
`;

S.FilterBtn = styled.div`
    margin-left: 1rem;
    margin-right: 1rem;
    font-size: 13px;
    cursor: pointer;
    height: 3.4rem;
    white-space: nowrap;
    color: ${({ theme: { $groupFilterBtnFilterTextColor } }) => $groupFilterBtnFilterTextColor};
    &.active {
        color: ${({ theme: { $groupFilterBtnFilterTextActiveColor } }) => $groupFilterBtnFilterTextActiveColor};
        border-bottom: 2px solid ${({ theme: { $groupFilterBtnFilterTextActiveColor } }) => $groupFilterBtnFilterTextActiveColor};
    }
`;

S.FilterCategoriesContainer = styled.div`
    width: 100%;
    -webkit-overflow-scrolling: touch;
    &.ps{
        & .ps__scrollbar-y-rail{
           & .ps__scrollbar-y{
               background-color: #F05A22!important;
           }
       }
     }
`;


S.FilterCategoryRow = styled.div`
    margin-top: 1px; 
    height: 23px;
    line-height: 23px;
    display: flex;
    padding: 0.8rem;
    justify-content: space-between;
    background-color: ${({ theme: { $groupFilterCategoryContainerBgColor } }) => $groupFilterCategoryContainerBgColor};
    &:last-of-type {
        margin-bottom: 1px;
    }
`;

S.FilterCategoryNameContainer = styled.div`
   display: flex;
   width: 80%;
`;

S.FilterCategoryFlag = styled.img`
    width: 16px;
    height: 16px;
    margin-right: 1rem;
    margin-top: 4px;
`;

S.FilterCategoryName = styled.div`
    font-size: 13px;
    color: ${({ theme: { $groupFilterCategoryNameColor } }) => $groupFilterCategoryNameColor};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

S.FilterCheckboxContainer = styled.div`
    display: flex;
`;

S.FilterEventCount = styled.div`
    font-size: 13px;
    color: ${({ theme: { $groupFilterCountTextColor } }) => $groupFilterCountTextColor};
`;

S.FakeChbox = styled.div`
    width: 18px;
    height: 18px;
    border: 2px solid ${({theme:{$groupFilterCheckboxBorderColor}}) => $groupFilterCheckboxBorderColor};
    background-color: transparent;
    border-radius: 2px;
    margin-right: 2px;
    margin-left: 12px;
    &.is-active {
        border-color: ${({theme:{$groupFilterCheckboxActiveBorderColor}}) => $groupFilterCheckboxActiveBorderColor};
        background-color:  ${({theme:{$groupFilterCheckboxActiveBorderColor}}) => $groupFilterCheckboxActiveBorderColor};
        &:after {
            content: "\f3fd";
            display: block;
            margin-left: 2px;
            font-family: Ionicons;
            font-size: 30px;
            margin-top: -2px!important;
            position: aabsolute;
            color: ${({theme:{$groupFilterCheckboxActiveCheckColor}}) => $groupFilterCheckboxActiveCheckColor};; 
        }
}
`;

S.FooterPanel = styled.div`
    width: 100%;
    &.fixed-bottom {
        position: fixed;
        bottom: 56px;
    }
`;

S.ClearSelectionButton = styled(Button)`
    border: 0px;
    height: 3rem;
    width: 50%;
    color: ${({theme:{$groupFilterButtonActiveBgColor}}) => $groupFilterButtonActiveBgColor};
    background-color: ${({theme: {$groupFilterButtonClearBgColor}}) => $groupFilterButtonClearBgColor};
    background-image: url(/images/svg/close_btn_orange.svg);
    background-repeat: no-repeat;
    background-size: 10px 10px;
    background-position: 17px 19px;
    font-size: 1.1rem;
    &.hidden {
        display: none;
    }
`;

S.ShowEventsButton = styled(Button)`
    height: 3rem;
    width: 50%;
    background-color: ${({ theme: { $groupFilterButtonActiveBgColor } }) => $groupFilterButtonActiveBgColor};
    color: ${({ theme: { $groupFilterButtonTextActiveColor } }) => $groupFilterButtonTextActiveColor};
    font-size: 1.1rem;        
    &.hidden {
        display: none;
    }
`;


export default S;